<template>
  <v-container fluid>
    <v-toolbar dense outlined flat>
      <v-spacer />
      <v-btn-toggle v-model="computedSettings.viewMode" mandatory dense>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn v-on="on" text value="dashboard">
              <v-icon>mdi-view-dashboard</v-icon>
            </v-btn>
          </template>
          <span>Dashboard</span>
        </v-tooltip>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn v-on="on" text value="tabular">
              <v-icon>mdi-view-list</v-icon>
            </v-btn>
          </template>
          <span>Tabular</span>
        </v-tooltip>
      </v-btn-toggle>
    </v-toolbar>
  </v-container>
</template>

<script>
export default {
  name: "OutputToolbar",
  components: {},
  mixins: [],
  props: {
    settings: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    computedSettings: {
      get() {
        return this.settings;
      },
      set(val) {
        this.$emit("update:settings", val);
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
